import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Loader2 } from "lucide-react";

interface UserTableProps<T extends { id: number; username: string; role: string } | { id: number; username: string; role: string; user: { id: number; username: string; role: string } }> {
  users: T[];
  isLoading?: boolean;
  error?: Error | null;
  renderActions: (user: T) => React.ReactNode;
}

export function UserTable<T extends { id: number; username: string; role: string } | { id: number; username: string; role: string; user: { id: number; username: string; role: string } }>({
  users,
  isLoading,
  error,
  renderActions,
}: UserTableProps<T>) {
  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-8">
        <Loader2 className="h-6 w-6 animate-spin" />
      </div>
    );
  }

  if (error) {
    return <div className="text-destructive">Error: {error.message}</div>;
  }

  if (!users || users.length === 0) {
    return <div className="text-center py-8 text-slate-500">No users found.</div>;
  }

  return (
    <div className="rounded-xl border border-white/30 bg-white/20 backdrop-blur-sm overflow-hidden"
      style={{
        boxShadow: '0 4px 16px rgba(0,0,0,0.1), inset 0 1px 0 rgba(255,255,255,0.3)',
      }}>
      <Table>
        <TableHeader>
          <TableRow className="bg-white/20 backdrop-blur-sm border-b border-white/20">
            <TableHead className="text-slate-700/90 drop-shadow-sm">Username</TableHead>
            <TableHead className="text-slate-700/90 drop-shadow-sm">Role</TableHead>
            <TableHead className="text-right text-slate-700/90 drop-shadow-sm">Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {users.map((user) => {
            const userData = 'user' in user ? user.user : user;
            return (
              <TableRow key={userData.id} className="hover:bg-white/20 backdrop-blur-sm transition-all duration-200 border-b border-white/10">
                <TableCell>{userData.username}</TableCell>
                <TableCell>{userData.role}</TableCell>
                <TableCell className="text-right">
                  {renderActions(user)}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
}
